(function () {
  if (window.SuckerPunchProductSection) return;

  function parseHTML(html) {
    var template = document.createElement('template');
    template.innerHTML = html.trim();
    return template.content;
  }

  async function replace(url, sectionId, pushState) {
    if (pushState === undefined) pushState = true;

    var currentRoot = document.querySelector('[data-main-product-root="' + sectionId + '"]');

    if (!currentRoot) {
      return false;
    }

    var targetUrl = new URL(url, window.location.origin);
    targetUrl.searchParams.set('section_id', sectionId);

    try {
      var response = await fetch(targetUrl.toString(), {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'text/html'
        }
      });

      if (!response.ok) throw new Error('Failed to load section: ' + response.status);

      var sectionHTML = await response.text();
      var fragment = parseHTML(sectionHTML);
      var nextRoot = fragment.querySelector('[data-main-product-root="' + sectionId + '"]');

      if (!nextRoot) throw new Error('Updated product root not found');

      currentRoot.replaceWith(nextRoot);

      if (window.Alpine) {
        window.Alpine.initTree(nextRoot);
      }

      if (window.Shopify && window.Shopify.PaymentButton && window.Shopify.PaymentButton.init) {
        window.Shopify.PaymentButton.init();
      }

      var historyParams = new URLSearchParams(targetUrl.search);
      historyParams.delete('section_id');
      var historySearch = historyParams.toString();
      var historyUrl = targetUrl.pathname + (historySearch ? '?' + historySearch : '');

      document.dispatchEvent(
        new CustomEvent('product:section:updated', {
          detail: { sectionId: sectionId, url: historyUrl }
        })
      );

      if (pushState) {
        window.history.pushState(
          { productSection: true, sectionId: sectionId, url: historyUrl },
          '',
          historyUrl
        );
      }

      return false;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  window.SuckerPunchProductSection = {
    replace: replace
  };

  window.addEventListener('popstate', function () {
    var currentRoot = document.querySelector('[data-main-product-root]');

    if (!currentRoot) return;

    if (currentRoot.dataset.tasteSwitching === 'true') {
      return;
    }

    var historyUrl = window.location.pathname + window.location.search;
    replace(historyUrl, currentRoot.dataset.mainProductRoot, false);
  });
})();
